"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Message = _interopRequireDefault(require("../../components/Message"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RemainingCount = _styledComponents.default.span.withConfig({
  displayName: "HelpMessage__RemainingCount",
  componentId: "mfgk6-0"
})(["font-weight:", ";"], _designTokens.typography.weight.alias.semibold);

function HelpMessage(props) {
  var helpMessage = props.helpMessage,
      maxLength = props.maxLength,
      showCharacterCount = props.showCharacterCount,
      _props$contentLength = props.contentLength,
      contentLength = _props$contentLength === void 0 ? 0 : _props$contentLength;
  var translate = (0, _useTranslations.default)();
  var showCount = Boolean(maxLength && showCharacterCount); // You have {remaining} characters left ({max} max).

  var countMessage = showCount && translate(undefined, 'textArea.countMessage', {
    remaining: _react.default.createElement(RemainingCount, null, maxLength - contentLength),
    max: "".concat(maxLength)
  });
  return helpMessage || showCount ? _react.default.createElement(_Message.default, {
    intent: "help"
  }, helpMessage, helpMessage && showCount && _react.default.createElement("br", null), countMessage) : null;
}

HelpMessage.displayName = 'HelpMessage';
HelpMessage.propTypes = {
  helpMessage: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  showCharacterCount: _propTypes.default.bool,
  contentLength: _propTypes.default.number.isRequired
};
HelpMessage.defaultProps = {
  helpMessage: undefined,
  maxLength: 0,
  showCharacterCount: false
};
var _default = HelpMessage;
exports.default = _default;